import React, { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Badge, Card, Col, Container, Modal, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { getSchoolBySelection } from '../../actions/schoolsActions'
import { getPrecandidates, getSelection } from '../../actions/selectionsActions'
import SubMenuSelection from '../../components/menus/SubMenuSelection'
import { getLevels, getCourseSubjects } from '../../actions/miscellaneousActions'
import { getChoosesBySelection } from '../../actions/choosesActions'
import { registerChartPlugins } from '../../hooks/ChartJSHook';
// import CandidateProfile from '../admin/CandidateProfile'

export default function GeneralData() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const params = useParams()
    const dispatch = useDispatch()

    const {school} = useSelector(state=>state.schools)
    const {selection} = useSelector(state=>state.selections)
    const {chooses} = useSelector(state => state.chooses)
    const {subjects, levels} = useSelector(state => state.miscellaneous)

    const [requirementsPrimary, setRequirementsPrimary] = useState()
    const [requirementsSecondary, setRequirementsSecondary] = useState()
    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)

    registerChartPlugins() // Inicializa los plugins de Chart.js
    const dataPrimary = {
        labels: [(t('selection.primary')), (t('selection.rest'))],
        datasets: [
          {
            data: [selection?.requirementWeighting?.primary, 100 - selection?.requirementWeighting?.primary],
            backgroundColor: ['#89CF2B', '#DEF3BE'],
            hoverBackgroundColor: ['#89CF2BAA', '#DEF3BEAA'],
          },
        ]
    }
    const dataSecondary = {
        labels: [(t('selection.secondary')), (t('selection.rest'))],
        datasets: [
          {
            data: [selection?.requirementWeighting?.secondary, 100 - selection?.requirementWeighting?.secondary],
            backgroundColor: ['#89CF2B', '#DEF3BE'],
            hoverBackgroundColor: ['#89CF2BAA', '#DEF3BEAA'],
          },
        ]
    }
    const dataValues = {
        labels: [(t('selection.values')), (t('selection.rest'))],
        datasets: [
          {
            data: [selection?.requirementWeighting?.values, 100 - selection?.requirementWeighting?.values],
            backgroundColor: ['#89CF2B', '#DEF3BE'],
            hoverBackgroundColor: ['#89CF2BAA', '#DEF3BEAA'],
          },
        ]
    }
    const videosData = {
        labels: [(t('selection.videoSaw')), (t('selection.videoNoSaw'))],
        datasets: [
          {
            data: [chooses?.filter(c => c.videoSaw).length, chooses?.filter(c => c.videoPresentation && !c.videoSaw).length],
            backgroundColor: ['#89CF2B', '#DEF3BE'],
            hoverBackgroundColor: ['#89CF2BAA', '#DEF3BEAA'],
          },
        ]
    }
    const interviewsData = {
        labels: [(t('selection.interviewsDone')), (t('selection.interviewsPending'))],
        datasets: [
          {
            data: [chooses?.filter(c => c.schedule.days && c.candidateStatus === 1 && c.type === "candidate" && c.schedule.days.length === 1 && new Date(c.schedule.days[0].date) < new Date()).length, chooses?.filter(c => c.schedule.days && c.candidateStatus === 1 && c.type === "candidate" && c.schedule.days.length > 1).length],
            backgroundColor: ['#89CF2B', '#DEF3BE'],
            hoverBackgroundColor: ['#89CF2BAA', '#DEF3BEAA'],
          },
        ]
    }
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
            tooltip: {
                callbacks: {
                  label: function (tooltipItem) {
                    const dataset = tooltipItem.dataset;
                    const currentValue = dataset.data[tooltipItem.dataIndex];
                    const total = dataset.data.reduce((acc, val) => acc + val, 0);
                    const percentage = ((currentValue / total) * 100).toFixed(2); // Calcula el porcentaje
                    return ` ${percentage}%`; // Retorna el texto del tooltip
                  },
                },
            },
            centerText: null
        },
    }

    const getPropertiesWithWeighting = (requirements, tipo) => {
        const properties = []; // Aseguramos que siempre es un array
    
        for (const key in requirements) {
            const value = requirements[key];
    
            if (Array.isArray(value)) {
                // Si el valor es un array, verifica si algún elemento tiene el weighting correcto
                if (value.some(item => item.weighting === tipo)) {
                    properties.push(key); // Agrega el nombre de la propiedad
                }
            } else if (typeof value === "object" && value !== null) {
                // Si es un objeto, revisa sus subpropiedades
                for (const subKey in value) {
                    const subValue = value[subKey];

                    if (tipo === "primary" && subKey === "officeLevel" && subValue !== "none") {
                        properties.push(`${key}.${subKey}`);
                    }

                    if (Array.isArray(subValue)) {
                        if (subValue.some(item => item.weighting === tipo)) {
                            properties.push(`${key}.${subKey}`);
                        }
                    }
                }
            }
        }
    
        return properties; // Siempre devuelve un array
    };

    useEffect(() => {
        if(client){
            dispatch(getSchoolBySelection(params.id))
            dispatch(getLevels())
            dispatch(getCourseSubjects())
        }
    },[dispatch, t, client, params.id])

    useEffect(()=>{
        if(selection){
            setRequirementsPrimary(getPropertiesWithWeighting(selection?.requirements, "primary"))
            setRequirementsSecondary(getPropertiesWithWeighting(selection?.requirements, "secondary"))
        }
    },[selection])

    useEffect(() => {
        if(school){
            dispatch(getChoosesBySelection(params.id))
            dispatch(getSelection(params.id))
            dispatch(getPrecandidates(params.id))
        }
    },[school, dispatch, params.id])

    return (
        <>
            <Container className='cuerpo'>
                <Row className="mb-5">
                    <Col className='d-flex align-items-center'>
                        <img src="/images/config.svg" alt="Icono Configuración" />
                        <h1 className='ms-2 m-0'>{t('menus.activeSelection')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra lateral'>
                            <Card.Body className='p-5'>
                                <SubMenuSelection selection={selection} section="generalData"/>
                                <Row className='my-3'>
                                    <Col xs={12}>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <h4 className='m-0'>{t('selection.submenu.generalData')}</h4>
                                            <div className='d-flex align-items-center justify-content-end'>
                                                <Badge className="candidates">
                                                    <img src="/images/menus/user.svg" alt="Candidatos"  /> {chooses?.filter(choose => choose.candidateStatus !== 2).length} {t('selection.submenu.candidates')}
                                                </Badge>
                                                <Badge className="candidates ms-2">
                                                    <img src="/images/menus/user.svg" alt="Candidatos"  /> {isNaN(selection?.precandidates) || 0 ? 0 : selection?.precandidates} {t('selection.submenu.precandidates')}
                                                </Badge>
                                                <Badge className="inprocess ms-2">
                                                    <img src="/images/time.svg" alt="En proceso" /> {selection?.progressPercentage}% {t('selection.inprocess')}
                                                </Badge>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Container className='cuadro-datos-generales'>
                                    <Row className='py-3'>
                                        <Col xs={12} md={6} className='d-flex justify-content-between'>
                                            <div className='title'>{(t('selection.specialty'))}</div>
                                            <div className='data'>{(t('levels.'+levels?.find(level => level.id === selection?.specialty)?.label))}</div>
                                        </Col>
                                        <Col xs={12} md={6} className='d-flex justify-content-between'>
                                            <div className='title'>{t(selection?.specialty == 1 ? "profile.candidate.position" : "selection.subject")}</div>
                                            <div className='data'>{(t('subjects.'+subjects?.find(level => level.id === selection?.subject)?.label))}</div>
                                        </Col>
                                    </Row>
                                    <Row className='py-3'>
                                        <Col xs={12} md={6} className='d-flex justify-content-between'>
                                            <div className='title'>{(t('selection.rangeage'))}</div>
                                            <div className='data'>{selection?.ageRange.min} - {selection?.ageRange.max}</div>
                                        </Col>
                                        <Col xs={12} md={6} className='d-flex justify-content-between'>
                                            <div className='title'>{(t('selection.salary'))}</div>
                                            <div className='data'>{selection?.miniumSalary ? selection.miniumSalary : t('selection.byAgreement')}</div>
                                        </Col>
                                    </Row>
                                    <Row className='py-3'>
                                        <Col xs={12} md={6} className='d-flex justify-content-between'>
                                            <div className='title'>{(t('selection.contractType'))}</div>
                                            <div className='data'>
                                                {
                                                    selection?.fixedDiscontinuous
                                                    ?
                                                        t('selection.fixedDiscontinuous')
                                                    :
                                                        t('profile.candidate.'+selection?.contractType)
                                                }
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} className='d-flex justify-content-between'>
                                            <div className='title'>{(t('profile.candidate.idealPosition.workDay.label'))}</div>
                                            <div className='data'>{(t('profile.candidate.idealPosition.workDay.'+selection?.workdayType))}</div>
                                        </Col>
                                    </Row>
                                    <Row className='py-3'>
                                        <Col xs={12} md={6} className='d-flex justify-content-between'>
                                            <div className='title'>{(t('selection.bachillerIB'))}</div>
                                            <div className='data'>{selection?.bachillerIB ? t('global.yes') : t('global.no')}</div>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <div className='d-flex justify-content-between'>
                                                <div className='title'>{(t('selection.videoPresentation'))}</div>
                                                <div className='d-flex justify-content-end align-items-center'>
                                                    <div className='data'>{selection?.videoPresentation ? t('global.yes') : t('global.no')}</div>
                                                    {
                                                        selection?.videoPresentation &&selection?.questions
                                                        ?
                                                        Object.keys(selection?.questions)?.length > 0 &&
                                                            <i className='fas fa-list cursor ms-2' onClick={handleShow}></i>
                                                        :
                                                        <></>
                                                    }
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='py-3'>
                                        <Col xs={12}>
                                            <div className='title mb-2'>{(t('selection.description'))}</div>
                                            <div className='data'>{selection?.profileDescription}</div>
                                        </Col>
                                    </Row>
                                </Container>
                                <Row className='my-3 py-2'>
                                    <Col xs={12} lg={4}>
                                        <h4>{(t('selection.primary'))}</h4>
                                        <div className='d-flex align-items-center'>
                                            <div className='chartRequirements'>
                                                <Doughnut data={dataPrimary} options={options} />
                                            </div>
                                            <div className='ms-3'>
                                                <h4>{(t('selection.weighing'))}</h4>
                                                <h4 className='weight'>{selection?.requirementWeighting?.primary} % {(t('selection.ofvalue'))}</h4>
                                            </div>
                                        </div>
                                        <div className='my-3'>
                                            {requirementsPrimary?.map(prop => (<Badge className='requirements' key={prop}>{t(`selection.requirementsList.${prop}`)}</Badge>))}
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <h4>{(t('selection.secondary'))}</h4>
                                        <div className='d-flex align-items-center'>
                                            <div className='chartRequirements'>
                                                <Doughnut data={dataSecondary} options={options} />
                                            </div>
                                            <div className='ms-3'>
                                                <h4>{(t('selection.weighing'))}</h4>
                                                <h4 className='weight'>{selection?.requirementWeighting?.secondary} % {(t('selection.ofvalue'))}</h4>
                                            </div>
                                        </div>
                                        <div className='my-3'>
                                            {requirementsSecondary?.map(prop => (<Badge className='requirements' key={prop}>{t(`selection.requirementsList.${prop}`)}</Badge>))}
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <h4>{(t('selection.values'))}</h4>
                                        <div className='d-flex align-items-center'>
                                            <div className='chartRequirements'>
                                                <Doughnut data={dataValues} options={options} />
                                            </div>
                                            <div className='ms-3'>
                                                <h4>{(t('selection.weighing'))}</h4>
                                                <h4 className='weight'>{selection?.requirementWeighting?.values} % {(t('selection.ofvalue'))}</h4>
                                            </div>

                                        </div>
                                    </Col>
                                </Row>
                                <div className='my-3 py-2'>
                                    <h4>{(t('selection.tasks'))}</h4>
                                    <Row>
                                        {
                                            selection?.videoPresentation &&
                                            <Col xs={12} lg={selection?.videoPresentation ? 4 : 6} className='my-3 d-flex align-items-center'>
                                                <div className='chartRequirements'>
                                                    <Doughnut data={videosData} options={options} />
                                                </div>
                                                <div className='ms-3'>
                                                    <h4>{(t('selection.presentationVideos'))}</h4>
                                                    <h4 className='weight'>{chooses?.filter(c => c.videoPresentation).length} {(t('selection.uploadedVideos'))}</h4>
                                                </div>
                                            </Col>
                                        }
                                        <Col xs={12} lg={selection?.videoPresentation ? 4 : 6} className='my-3 d-flex align-items-center'>
                                            <div className='chartRequirements'>
                                                <Doughnut data={interviewsData} options={options} />
                                            </div>
                                            <div className='ms-3'>
                                                <h4>{(t('selection.interviewRequest'))}</h4>
                                                <h4 className='weight'>{chooses?.filter(c => c.schedule.days && c.schedule.days.length > 0).length} {(t('selection.interviewRequest'))}</h4>
                                            </div>
                                        </Col>
                                        <Col xs={12} lg={selection?.videoPresentation ? 4 : 6} className='my-3 d-flex align-items-center'>
                                            <div className='ms-3'>
                                                <h4>{chooses?.filter(c => c.offerLetter).length} {(t('selection.offerLetterSent'))}</h4>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal size="lg" centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <h4>{(t('selection.questionsSchool'))}</h4>
                </Modal.Header>
                <Modal.Body>
                {
                    selection?.questions
                    ?
                        Object.keys(selection?.questions)?.length > 0
                        ?
                            <ul>
                            {/* Mapear las preguntas */}
                            {Object.entries(selection?.questions)?.map(([key, question], index) => (
                                <p key={index}>
                                {question}
                                </p>
                            ))}
                            </ul>
                        :
                            <></>
                    :
                        <></>
                }
                </Modal.Body>
            </Modal>

        </>
    )
}